import {defineMessages} from "@project/i18n";

export const supplierFunctionFieldLabelIds = {
  code: "fields.supplierFunction.code",
  description: "fields.supplierFunction.description",
  name: "fields.supplierFunction.name",
} as const;

export const supplierFunctionFieldMessages = defineMessages({
  code: {
    id: "fields.supplierFunction.code",
    defaultMessage: "Code",
    description: "Supplier function field label for code",
  },
  description: {
    id: "fields.supplierFunction.description",
    defaultMessage: "Description",
    description: "Supplier function field label for description",
  },
  name: {
    id: "fields.supplierFunction.name",
    defaultMessage: "Name",
    description: "Supplier function field label for name",
  },
});
